<!-- <app-news-banner></app-news-banner> -->
<section class="banner_section">
  <div class="containerFluid">
    <div class="bannerWrapper">
      <div class="bannerContent">
        <h1 style="font-size: 38px">
          We Provide a Loving Home for Orphans in Pakistan!
        </h1>
        <p>
          Nearly 4 million orphans in Pakistan face a daily struggle for
          survival. We are on a mission to change that!
        </p>
        <div class="bannerCTAs">
          <a href="javascript:;" routerLink="/donate" class="donateBtn"
            >Donate</a
          >
          <a
            href="javascript:;"
            routerLink="/sponsorship-program"
            class="sponsorBtn"
            >Sponsor a Child</a
          >
        </div>
      </div>
      <div class="bg_video">
        <video
          id="bannerVid"
          width="100%"
          height="100%"
          autoplay
          loop
          muted
          oncanplay="this.play()"
          onloadedmetadata="this.muted = true"
        >
          <source
            src="assets/images//home-new/homepage-top-video.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</section>

<section class="our-work">
  <div class="container p-0">
    <div class="swiper-container ourWorkSlider">
      <div class="our-work-heading">
        <h2>World Leaders Acknowledge Our Work for Orphans</h2>
      </div>
      <div class="witnessVideoWrapper">
        <div class="videoMiddle">
          <iframe
            width="1280"
            height="720"
            src="https://www.youtube.com/embed/NausMN-P-vw?autoplay=1&mute=1"
            title="World Leaders Acknowledge Our Work for Orphans"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="movingDiv">
  <p>We have been featured in</p>
  <div class="main_moving">
    <div class="moving_div">
      <img src="assets/images/aj_Aljazeera.png" alt="aljazeera" />
      <img src="assets/images/app.png" alt="app" />
      <img src="assets/images/ann.png" alt="ann" />
      <img src="assets/images/dawn.png" alt="dawn" />
      <img src="assets/images/cnn.png" alt="cnn" />
      <img src="assets/images/bbc.png" alt="bbc" />
    </div>
    <div class="moving_div moving_div2">
      <img src="assets/images/aj_Aljazeera.png" alt="aljazeera" />
      <img src="assets/images/app.png" alt="app" />
      <img src="assets/images/ann.png" alt="ann" />
      <img src="assets/images/dawn.png" alt="dawn" />
      <img src="assets/images/cnn.png" alt="cnn" />
      <img src="assets/images/bbc.png" alt="bbc" />
    </div>
  </div>
</div>

<section class="our-work second">
  <div class="container p-0">
    <div class="swiper-container ourWorkSlider">
      <div class="our-work-heading">
        <h2 class="ajstories">Witness the Change You Create</h2>
        <p>
          Discover the inspiring stories of orphaned children who have overcome
          adversity and flourished, thanks to your generous donations
        </p>
      </div>
      <div class="witnessVideoWrapper">
        <div class="videoMiddle">
          <iframe
            width="1280"
            height="720"
            src="https://www.youtube.com/embed/M2TCJUQ2n9k?autoplay=1&mute=1"
            title="Witness the Change You Create!!"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="inventoryRecordSec">
  <div class="container">
    <h2 class="secHead">Your Donations at Work</h2>
    <p class="descr">
      Take a look at the tangible impact your donations have on the lives of
      these children, as we work together to build a brighter future for them.
    </p>
    <div class="recordsWrapper">
      <div class="singleRecord">
        <svg
          width="96"
          height="79"
          viewBox="0 0 96 79"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3127 2.93793C13.7107 1.39024 15.9299 0.537082 17.9518 0.188819C27.9982 -1.54162 31.5518 12.7677 40.046 18.4046C47.1681 23.1309 55.6969 22.7224 60.408 21.3705C88.1672 12.5931 95.5991 30.2941 95.8452 40.2419C95.7442 49.4918 92.1831 56.5221 86.9304 61.7865C68.1927 80.5657 32.3528 85.225 13.6561 66.4051C8.90374 61.6214 5.78738 56.1833 4.29903 52.0913C-6.03684 27.5146 4.66817 9.08211 11.3127 2.93793Z"
            fill="#EAF6FF"
          />
          <path
            d="M44.9058 59.9874H44.7144L44.557 59.3598C43.8585 56.5771 43.1364 53.6995 42.4682 50.8629C41.4441 46.5139 40.3948 43.7398 34.5595 42.0886L28.8747 38.0051C27.9476 37.3392 26.8132 37.0747 25.6809 37.2603C25.6643 37.2631 25.6475 37.2659 25.631 37.2688L21.8263 28.2882C19.2983 22.3206 16.0354 23.009 15.0958 23.3623C12.7776 24.2335 11.4176 27.3071 12.2426 29.8108C12.2426 29.8108 17.1603 44.7388 17.2128 44.8997C17.9952 47.3012 18.9688 50.29 21.1972 51.8213L27.7632 56.3341C28.5042 56.8433 28.9656 57.516 29.1736 58.3909L29.5533 59.9868H28.7034C28.7037 59.9868 28.7033 59.9868 28.7034 59.9868C28.0057 59.9868 27.3512 60.2569 26.8612 60.7472C26.3711 61.2377 26.1017 61.8921 26.1024 62.5903L26.1062 66.5732C26.1077 68.0057 27.2743 69.1713 28.7068 69.1716L44.9094 69.1726C45.6074 69.1726 46.2615 68.9026 46.7514 68.4122C47.2414 67.9217 47.5109 67.2674 47.5103 66.5692L47.5064 62.5861C47.5051 61.1533 46.3385 59.9877 44.9058 59.9874ZM31.1793 57.9134C30.8523 56.5385 30.0958 55.4353 28.931 54.6348L22.3649 50.1221C20.7127 48.9864 19.8589 46.3662 19.1729 44.2607C19.1198 44.0977 14.2007 29.1654 14.2007 29.1654C13.6853 27.6009 14.6609 25.7278 15.821 25.2917C17.1692 24.7849 18.7049 26.2053 19.9279 29.0921L23.7442 38.1001C23.4227 38.3495 23.1357 38.6466 22.8923 38.9857C22.2264 39.9127 21.9619 41.0469 22.1474 42.1795C22.333 43.312 22.9459 44.3024 23.8729 44.9683L31.6252 50.5368C32.0878 50.8688 32.7319 50.7632 33.0638 50.3008C33.396 49.8385 33.2904 49.1943 32.828 48.8621L25.0757 43.2936C24.5959 42.9491 24.2786 42.435 24.182 41.8459C24.0854 41.2569 24.222 40.6683 24.5666 40.1885C24.9112 39.7086 25.4254 39.3913 26.0145 39.2947C26.6034 39.1986 27.1921 39.3347 27.6719 39.6794L33.5053 43.8696C33.6047 43.9408 33.7159 43.994 33.8338 44.0263C38.8566 45.4049 39.5281 47.3716 40.4617 51.3353C41.1332 54.1864 41.8573 57.0716 42.5575 59.8615L42.589 59.9871L31.6726 59.9866L31.1793 57.9134ZM45.293 66.9544C45.1926 67.0552 45.0563 67.1105 44.9095 67.1105L28.7071 67.1095C28.4101 67.1095 28.1681 66.8677 28.1679 66.5708L28.164 62.5879C28.1639 62.4409 28.2192 62.3046 28.3197 62.2041C28.4201 62.1037 28.5563 62.0482 28.7031 62.0482L44.9055 62.0491C45.2026 62.0491 45.4445 62.2909 45.4448 62.5878L45.4486 66.5707C45.4488 66.7177 45.3934 66.8539 45.293 66.9544ZM81.6482 23.3622C80.7085 23.0092 77.4458 22.3202 74.9177 28.288L71.1129 37.2687C71.0963 37.2657 71.0796 37.2629 71.063 37.2601C69.9304 37.0744 68.7962 37.339 67.8692 38.005L62.1844 42.0885C56.3491 43.7398 55.2999 46.5138 54.2755 50.8628C53.6074 53.6993 52.8853 56.5769 52.1868 59.3597L52.0294 59.9873H51.8378C50.4051 59.9876 49.2387 61.1531 49.2373 62.5857L49.2335 66.5689C49.2329 67.2668 49.5024 67.9212 49.9923 68.4117C50.4823 68.9021 51.1365 69.1722 51.8346 69.1722L68.0371 69.1712C69.4696 69.1709 70.6362 68.0053 70.6377 66.5728L70.6415 62.5898C70.6423 61.8918 70.3728 61.2372 69.8827 60.7467C69.3928 60.2563 68.7388 59.9864 68.0411 59.9864H67.1908L67.5704 58.3903C67.7785 57.5157 68.2397 56.8429 68.9807 56.3336L75.5469 51.8209C77.7752 50.2895 78.7491 47.3006 79.5315 44.8989C79.5837 44.7381 84.5015 29.8104 84.5015 29.8104C85.3261 27.307 83.9662 24.2334 81.6482 23.3622ZM68.0406 62.0482C68.1875 62.0482 68.3237 62.1036 68.4241 62.2041C68.5245 62.3047 68.5799 62.4409 68.5798 62.5879L68.5759 66.5708C68.5756 66.8679 68.3337 67.1095 68.0368 67.1095L51.8344 67.1105C51.6874 67.1105 51.5512 67.0552 51.4508 66.9544C51.3502 66.8539 51.295 66.7177 51.2951 66.5708L51.299 62.5878C51.2993 62.2907 51.5412 62.0491 51.8381 62.0491L68.0406 62.0482ZM82.5432 29.1655C82.5432 29.1655 77.6242 44.0975 77.571 44.2605C76.8851 46.3661 76.0314 48.9866 74.379 50.1222L67.8128 54.6348C66.648 55.4355 65.8915 56.5386 65.5645 57.9136L65.0713 59.9868L54.1549 59.9874L54.1864 59.8618C54.8867 57.0718 55.6107 54.1867 56.2822 51.3356C57.2157 47.3718 57.8874 45.4053 62.9101 44.0265C63.0281 43.9942 63.1392 43.9411 63.2386 43.8699L69.0719 39.6797C69.5517 39.335 70.1406 39.1989 70.7293 39.2949C71.3183 39.3916 71.8324 39.709 72.1772 40.1888C72.5218 40.6686 72.6584 41.2572 72.5618 41.8462C72.4652 42.4353 72.1479 42.9493 71.6681 43.2939L63.9157 48.8624C63.4534 49.1946 63.3478 49.8387 63.68 50.3011C64.0121 50.7635 64.6562 50.8691 65.1186 50.5371L72.8708 44.9686C73.7978 44.3028 74.4107 43.3123 74.5964 42.1798C74.782 41.0472 74.5174 39.913 73.8517 38.986C73.6081 38.647 73.3211 38.35 72.9996 38.1004L76.8158 29.0923C78.0387 26.2058 79.5737 24.786 80.9228 25.292C82.083 25.7279 83.0586 27.6011 82.5432 29.1655ZM50.5633 40.6571C52.4363 38.8355 54.3045 37.1478 56.1114 35.5157C62.9104 29.3742 68.7822 24.0702 68.7822 16.739C68.7822 11.3689 64.3033 7 58.798 7C54.306 7 51.8771 9.03749 49.8446 12.4299C47.812 9.03749 45.3831 7 40.8912 7C35.3859 7 30.907 11.3689 30.907 16.739C30.907 24.0702 36.7789 29.3742 43.5779 35.5157C45.3847 37.1478 47.2532 38.8355 49.126 40.6571C49.326 40.8516 49.5855 40.949 49.8446 40.949C50.1038 40.949 50.3631 40.8516 50.5633 40.6571ZM44.9596 33.9858C38.2602 27.9342 32.9685 23.1542 32.9685 16.739C32.9685 12.5057 36.5226 9.06164 40.8911 9.06164C44.6045 9.06164 46.6325 10.5684 48.9278 15.0332C49.1045 15.3767 49.4584 15.5928 49.8446 15.5928C50.2309 15.5928 50.5848 15.3767 50.7615 15.0332C53.0567 10.5685 55.0846 9.06164 58.7982 9.06164C63.1668 9.06164 66.7207 12.5057 66.7207 16.739C66.7207 23.1542 61.4291 27.9342 54.7297 33.9858C53.1388 35.4229 51.5006 36.9027 49.8448 38.4863C48.1887 36.9027 46.5504 35.4229 44.9596 33.9858Z"
            fill="#303030"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.5633 40.6571C52.4363 38.8355 54.3045 37.1478 56.1114 35.5157C62.9104 29.3742 68.7822 24.0702 68.7822 16.739C68.7822 11.3689 64.3033 7 58.798 7C54.306 7 51.8771 9.03749 49.8446 12.4299C47.812 9.03749 45.3831 7 40.8912 7C35.3859 7 30.907 11.3689 30.907 16.739C30.907 24.0702 36.7789 29.3742 43.5778 35.5157C45.3847 37.1478 47.2532 38.8355 49.126 40.6571C49.326 40.8516 49.5855 40.949 49.8446 40.949C50.1038 40.949 50.3631 40.8516 50.5633 40.6571ZM44.9672 33.9926L44.9596 33.9858C38.2602 27.9342 32.9685 23.1542 32.9685 16.739C32.9685 12.5057 36.5226 9.06164 40.8911 9.06164C44.6045 9.06164 46.6325 10.5684 48.9278 15.0332C49.1045 15.3767 49.4584 15.5928 49.8446 15.5928C50.2309 15.5928 50.5848 15.3767 50.7615 15.0332C53.0567 10.5685 55.0846 9.06164 58.7982 9.06164C63.1668 9.06164 66.7207 12.5057 66.7207 16.739C66.7207 23.1542 61.4291 27.9342 54.7297 33.9858L54.7223 33.9924C53.1338 35.4275 51.498 36.9051 49.8448 38.4863C48.1913 36.9052 46.5556 35.4276 44.9672 33.9926Z"
            fill="#00AAE9"
          />
        </svg>

        <p class="recordValue" data-rel2="10,000+" data-rel="+">10000</p>
        <p class="recordLabel">Orphans Supported</p>
      </div>
      <div class="singleRecord">
        <svg
          width="114"
          height="80"
          viewBox="0 0 114 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.0318 7.66621C53.821 10.0566 53.0879 12.8281 52.5885 15.6126C51.4217 22.1177 45.5779 26.9811 39.0993 28.2866C28.3771 30.4472 15.6117 35.3588 13.4771 37.5653C-6.33439 58.6564 20.9301 82.5973 49.492 77.9549C51.9247 77.5595 54.2239 77.128 56.3229 76.6897C60.0239 75.9168 63.7662 75.249 67.5074 74.7026C79.8308 72.9029 89.1333 69.7593 96.0521 66.1065C112.473 57.4373 116.439 34.7934 105.211 20.0038C102.862 16.9096 100.192 14.2785 97.393 12.0627C84.9439 2.20759 62.2066 -6.49806 55.0318 7.66621Z"
            fill="#EAF6FF"
          />
          <g clip-path="url(#clip0_847_1687)">
            <path
              d="M95.7683 26.1696L64.2582 10.6488C61.5418 9.27927 56.9239 9.27927 54.2075 10.6488L21.973 26.1696C19.7094 27.2652 19.3472 28.8173 19.3472 29.639C19.3472 30.4607 19.7094 31.9215 21.973 33.1084L24.5989 34.3866V48.9945C22.969 49.6336 21.7919 51.2769 21.7919 53.1029C21.7919 54.9289 22.969 56.5723 24.5083 57.2114L20.4337 70.2672H31.8426L27.768 57.2114C29.3978 56.5723 30.4844 54.9289 30.4844 53.1029C30.4844 51.1856 29.3073 49.6336 27.6774 48.9945V35.9387L32.4764 38.3124V57.3027C32.4764 57.5766 32.5669 57.8505 32.748 58.1244C33.2008 58.6722 41.6216 70.2672 58.8254 70.2672C76.0292 70.2672 84.45 58.5809 84.8122 58.1244C84.9933 57.8505 85.0839 57.5766 85.0839 57.3027V38.4037L95.7683 33.1084C98.032 32.0128 98.3942 30.4607 98.3942 29.639C98.3036 28.8173 98.032 27.2652 95.7683 26.1696ZM82.1864 56.8462C80.7376 58.6722 72.9506 67.4369 58.8254 67.4369C44.7002 67.4369 36.9132 58.6722 35.4644 56.8462V39.5906L54.2075 48.6293C55.5657 49.2684 57.3767 49.6336 59.1876 49.6336C61.0891 49.6336 62.9 49.2684 64.2582 48.538L82.1864 39.6819V56.8462ZM94.5007 30.552L83.6351 35.9387C83.1824 35.9387 82.8202 36.1213 82.6391 36.4865L62.9905 46.0729C61.0891 47.0772 57.3767 47.0772 55.3846 46.0729L31.2087 34.3866L59.0065 31.0998C59.8214 31.0085 60.3647 30.2781 60.2741 29.5477C60.1836 28.726 59.4592 28.1782 58.7349 28.2695L26.5003 32.1041L23.2407 30.552C22.4257 30.1868 22.2447 29.7303 22.2447 29.7303C22.2447 29.639 22.4257 29.2738 23.2407 28.9086L55.4752 13.2964C56.4712 12.8399 57.8294 12.566 59.1876 12.566C60.6363 12.566 62.0851 12.8399 62.9905 13.2964L94.5007 28.8173C95.3156 29.1825 95.4967 29.5477 95.4967 29.7303C95.4967 29.7303 95.2251 30.1868 94.5007 30.552Z"
              fill="#303030"
              stroke="white"
              stroke-width="0.475846"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.6774 35.9387L31.2087 34.3866L59.0065 31.0998C59.8214 31.0085 60.3647 30.2781 60.2741 29.5477C60.1836 28.726 59.4592 28.1782 58.7349 28.2695L26.5003 32.1041L24.5989 34.3866V48.9945C22.969 49.6336 21.7919 51.277 21.7919 53.1029C21.7919 54.9289 22.969 56.5723 24.5083 57.2114L20.4337 70.2672H31.8426L27.768 57.2114C29.3978 56.5723 30.4844 54.9289 30.4844 53.1029C30.4844 51.1856 29.3073 49.6336 27.6774 48.9945V35.9387Z"
              fill="#00AAE9"
            />
          </g>
          <defs>
            <clippath id="clip0_847_1687">
              <rect
                width="80.8939"
                height="79.7043"
                fill="white"
                transform="translate(17.6411 0.0923462)"
              />
            </clippath>
          </defs>
        </svg>
        <p class="recordValue" data-rel>5</p>
        <p class="recordLabel">Successful Centers Built</p>
      </div>
      <div class="singleRecord">
        <svg
          width="114"
          height="80"
          viewBox="0 0 114 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.64375 34.5688C8.31322 7.16434 33.8207 2.73218 51.0406 3.78289C72.3569 4.79224 90.5907 16.4636 97.6685 22.9124C122.982 50.8384 111.845 67.3131 101.853 74.3226C87.198 83.0705 65.5633 66.0035 58.6244 59.9753C44.3024 48.5357 34.4247 56.7338 27.6245 61.5002C22.4896 64.676 18.1934 65.791 14.6126 65.6136C1.73153 64.9755 -1.40595 47.0999 1.64375 34.5688Z"
            fill="#EAF6FF"
          />
          <path
            d="M57 20C53.0444 20 49.1776 21.173 45.8886 23.3706C42.5996 25.5682 40.0362 28.6918 38.5224 32.3463C37.0087 36.0009 36.6126 40.0222 37.3843 43.9018C38.156 47.7814 40.0608 51.3451 42.8579 54.1421C45.6549 56.9392 49.2186 58.844 53.0982 59.6157C56.9778 60.3874 60.9992 59.9913 64.6537 58.4776C68.3082 56.9638 71.4318 54.4004 73.6294 51.1114C75.827 47.8224 77 43.9556 77 40C76.994 34.6975 74.8849 29.614 71.1355 25.8645C67.3861 22.1151 62.3025 20.006 57 20ZM57 57.5C53.5388 57.5 50.1554 56.4736 47.2775 54.5507C44.3997 52.6278 42.1567 49.8947 40.8321 46.697C39.5076 43.4993 39.161 39.9806 39.8363 36.5859C40.5115 33.1913 42.1782 30.0731 44.6256 27.6256C47.0731 25.1782 50.1913 23.5115 53.5859 22.8363C56.9806 22.161 60.4993 22.5076 63.697 23.8321C66.8947 25.1566 69.6278 27.3997 71.5507 30.2775C73.4737 33.1554 74.5 36.5388 74.5 40C74.4948 44.6397 72.6493 49.0878 69.3686 52.3686C66.0878 55.6493 61.6397 57.4947 57 57.5Z"
            fill="#303030"
          />
          <path
            d="M93.2499 6.25H90.7499C87.7672 6.25335 84.9077 7.43969 82.7986 9.54875C80.6896 11.6578 79.5032 14.5173 79.4999 17.5V20.1562C76.8594 17.1618 73.6476 14.7246 70.0529 12.9875C66.4582 11.2505 62.5529 10.2485 58.5659 10.0404C54.5789 9.8323 50.5905 10.4222 46.8345 11.7756C43.0785 13.129 39.6305 15.2186 36.6925 17.9219L36.0239 7.42031C36.0002 7.0915 35.8474 6.78539 35.599 6.56863C35.3506 6.35188 35.0267 6.24203 34.6977 6.26301C34.3687 6.28398 34.0613 6.43408 33.8424 6.68063C33.6235 6.92718 33.5109 7.2502 33.5291 7.57937L34.3228 20.0464C33.7471 20.4516 32.1103 21.0602 29.4999 21.2134V7.5C29.4999 7.16848 29.3682 6.85054 29.1338 6.61612C28.8993 6.3817 28.5814 6.25 28.2499 6.25C27.9184 6.25 27.6004 6.3817 27.366 6.61612C27.1316 6.85054 26.9999 7.16848 26.9999 7.5V21.2133C24.5385 21.0661 22.8207 20.5056 22.1771 20.0425L22.9707 7.57953C22.9888 7.25036 22.8762 6.92733 22.6574 6.68079C22.4385 6.43424 22.1311 6.28414 21.8021 6.26316C21.4731 6.24219 21.1491 6.35203 20.9007 6.56879C20.6523 6.78554 20.4996 7.09165 20.4758 7.42047L19.51 22.5864C19.4244 24.0445 19.8898 25.4815 20.8141 26.6124C21.7384 27.7433 23.0539 28.4856 24.4999 28.6919V41.25C24.1684 41.25 23.8504 41.3817 23.616 41.6161C23.3816 41.8505 23.2499 42.1685 23.2499 42.5V66.25C23.2499 67.5761 23.7767 68.8479 24.7143 69.7855C25.652 70.7232 26.9238 71.25 28.2499 71.25C29.576 71.25 30.8477 70.7232 31.7854 69.7855C32.7231 68.8479 33.2499 67.5761 33.2499 66.25V58.3247C36.4346 62.4483 40.6379 65.6717 45.4464 67.678C50.2548 69.6843 55.5027 70.4043 60.6738 69.7671C65.8449 69.1299 70.7611 67.1576 74.9387 64.0441C79.1163 60.9306 82.4114 56.7832 84.4999 52.0098V66.25C84.4999 67.5761 85.0267 68.8479 85.9643 69.7855C86.902 70.7232 88.1738 71.25 89.4999 71.25C90.826 71.25 92.0977 70.7232 93.0354 69.7855C93.9731 68.8479 94.4999 67.5761 94.4999 66.25V7.5C94.4999 7.16848 94.3682 6.85054 94.1338 6.61612C93.8993 6.3817 93.5814 6.25 93.2499 6.25ZM30.7499 66.25C30.7499 66.913 30.4865 67.5489 30.0176 68.0178C29.5488 68.4866 28.9129 68.75 28.2499 68.75C27.5868 68.75 26.9509 68.4866 26.4821 68.0178C26.0133 67.5489 25.7499 66.913 25.7499 66.25V43.75H30.7499V66.25ZM26.9999 41.25V28.75H29.4999V41.25H26.9999ZM31.1778 26.25H25.3219C24.8705 26.25 24.4238 26.158 24.0091 25.9796C23.5944 25.8012 23.2204 25.5401 22.91 25.2123C22.5996 24.8845 22.3593 24.4969 22.2038 24.0731C22.0482 23.6493 21.9807 23.1983 22.0053 22.7475C23.4069 23.3241 25.4686 23.75 28.2499 23.75C30.5341 23.75 32.828 23.4305 34.4941 22.7534C34.518 23.2037 34.45 23.6542 34.2941 24.0773C34.1383 24.5004 33.8979 24.8874 33.5876 25.2146C33.2773 25.5417 32.9036 25.8023 32.4893 25.9803C32.075 26.1583 31.6288 26.2501 31.1778 26.25ZM75.6374 60.2216C72.6133 63.0086 69.0027 65.0819 65.0713 66.2889C61.1399 67.4958 56.9879 67.8058 52.9209 67.1958C48.8539 66.5859 44.9755 65.0715 41.5712 62.7644C38.1669 60.4572 35.3233 57.4159 33.2499 53.8644V42.5C33.2499 42.1685 33.1182 41.8505 32.8838 41.6161C32.6493 41.3817 32.3314 41.25 31.9999 41.25V28.6919C33.4469 28.4854 34.7633 27.7423 35.6876 26.6101C36.6119 25.4778 37.0766 24.0393 36.9893 22.5803L36.9032 21.2302C39.6953 18.24 43.1194 15.9106 46.926 14.4118C50.7326 12.913 54.8257 12.2824 58.9069 12.5662C62.9881 12.85 66.9546 14.0409 70.5171 16.0522C74.0796 18.0634 77.1485 20.8443 79.4999 24.192V42.5C79.4999 42.8315 79.6316 43.1495 79.866 43.3839C80.1004 43.6183 80.4184 43.75 80.7499 43.75H84.245C83.3816 50.0754 80.3373 55.901 75.6374 60.2216ZM91.9999 66.25C91.9999 66.913 91.7365 67.5489 91.2676 68.0178C90.7988 68.4866 90.1629 68.75 89.4999 68.75C88.8368 68.75 88.201 68.4866 87.7321 68.0178C87.2633 67.5489 86.9999 66.913 86.9999 66.25V43.75H91.9999V66.25ZM91.9999 41.25H81.9999V17.5C82.0025 15.1802 82.9252 12.9561 84.5656 11.3157C86.2059 9.67531 88.43 8.75261 90.7499 8.75H91.9999V41.25Z"
            fill="#303030"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M93.2499 6.25H90.7499C87.7672 6.25335 84.9077 7.43969 82.7986 9.54875C80.6896 11.6578 79.5032 14.5173 79.4999 17.5V20.1562V24.192V42.5C79.4999 42.8315 79.6316 43.1495 79.866 43.3839C80.1004 43.6183 80.4184 43.75 80.7499 43.75H84.245C84.2168 43.95 84.4032 49.3399 84.4999 52.0098V66.25C84.4999 67.5761 85.0267 68.8479 85.9643 69.7855C86.902 70.7232 88.1738 71.25 89.4999 71.25C90.826 71.25 92.0977 70.7232 93.0354 69.7855C93.9731 68.8479 94.4999 67.5761 94.4999 66.25V7.5C94.4999 7.16848 94.3682 6.85054 94.1338 6.61612C93.8993 6.3817 93.5814 6.25 93.2499 6.25ZM33.2499 58.3247V53.8644V42.5C33.2499 42.1685 33.1182 41.8505 32.8838 41.6161C32.6493 41.3817 32.3314 41.25 31.9999 41.25V28.6919C33.4469 28.4854 34.7633 27.7423 35.6876 26.6101C36.6119 25.4778 37.0766 24.0393 36.9893 22.5803L36.9032 21.2302L36.6925 17.9219L36.0239 7.42031C36.0002 7.0915 35.8474 6.78539 35.599 6.56863C35.3506 6.35188 35.0267 6.24203 34.6977 6.26301C34.3687 6.28398 34.0613 6.43408 33.8424 6.68063C33.6235 6.92718 33.5109 7.2502 33.5291 7.57937L34.3228 20.0464C33.7471 20.4516 32.1103 21.0602 29.4999 21.2134V7.5C29.4999 7.16848 29.3682 6.85054 29.1338 6.61612C28.8993 6.3817 28.5814 6.25 28.2499 6.25C27.9184 6.25 27.6004 6.3817 27.366 6.61612C27.1316 6.85054 26.9999 7.16848 26.9999 7.5V21.2133C24.5385 21.0661 22.8207 20.5056 22.1771 20.0425L22.9707 7.57953C22.9888 7.25036 22.8762 6.92733 22.6574 6.68079C22.4385 6.43424 22.1311 6.28414 21.8021 6.26316C21.4731 6.24219 21.1491 6.35203 20.9007 6.56879C20.6523 6.78554 20.4996 7.09165 20.4758 7.42047L19.51 22.5864C19.4244 24.0445 19.8898 25.4815 20.8141 26.6124C21.7384 27.7433 23.0539 28.4856 24.4999 28.6919V41.25C24.1684 41.25 23.8504 41.3817 23.616 41.6161C23.3816 41.8505 23.2499 42.1685 23.2499 42.5V66.25C23.2499 67.5761 23.7767 68.8479 24.7143 69.7855C25.652 70.7232 26.9238 71.25 28.2499 71.25C29.576 71.25 30.8477 70.7232 31.7854 69.7855C32.7231 68.8479 33.2499 67.5761 33.2499 66.25V58.3247ZM30.7499 66.25C30.7499 66.913 30.4865 67.5489 30.0176 68.0178C29.5488 68.4866 28.9129 68.75 28.2499 68.75C27.5868 68.75 26.9509 68.4866 26.4821 68.0178C26.0133 67.5489 25.7499 66.913 25.7499 66.25V43.75H30.7499V66.25ZM26.9999 41.25V28.75H29.4999V41.25H26.9999ZM31.1778 26.25H25.3219C24.8705 26.25 24.4238 26.158 24.0091 25.9796C23.5944 25.8012 23.2204 25.5401 22.91 25.2123C22.5996 24.8845 22.3593 24.4969 22.2038 24.0731C22.0482 23.6493 21.9807 23.1983 22.0053 22.7475C23.4069 23.3241 25.4686 23.75 28.2499 23.75C30.5341 23.75 32.828 23.4305 34.4941 22.7534C34.518 23.2037 34.45 23.6542 34.2941 24.0773C34.1383 24.5004 33.8979 24.8874 33.5876 25.2146C33.2773 25.5417 32.9036 25.8023 32.4893 25.9803C32.075 26.1583 31.6288 26.2501 31.1778 26.25ZM91.9999 66.25C91.9999 66.913 91.7365 67.5489 91.2676 68.0178C90.7988 68.4866 90.1629 68.75 89.4999 68.75C88.8368 68.75 88.201 68.4866 87.7321 68.0178C87.2633 67.5489 86.9999 66.913 86.9999 66.25V43.75H91.9999V66.25ZM91.9999 41.25H81.9999V17.5C82.0025 15.1802 82.9252 12.9561 84.5656 11.3157C86.2059 9.67531 88.43 8.75261 90.7499 8.75H91.9999V41.25Z"
            fill="#00AAE9"
          />
        </svg>
        <p class="recordValue" data-rel2="1 Million+" data-rel="+">1000000</p>
        <p class="recordLabel">Meals Provided</p>
      </div>
    </div>
  </div>
</section>

<section class="celebrity_section">
  <div class="container">
    <div class="celebrity_main">
      <div class="main_left">
        <p class="heading">
          Get a glimpse into everyday life at Pakistan Sweet Home.
        </p>
        <div class="celebrity_left" #wistiajunaidbhai>
          <div class="witnessVideoWrapper junaidAkram">
            <!-- <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"> -->
            <!-- <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"> -->
            <!-- <div class="wistia_embed wistia_async_tu0ni0pxxk seo=true videoFoam=true"
                  style="height:100%;position:relative;width:100%">
                  <div class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                    <img src="https://fast.wistia.com/embed/medias/tu0ni0pxxk/swatch"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true"
                      onload="this.parentNode.style.opacity=1;" />
                  </div>
                </div> -->
            <iframe
              width="1280"
              height="720"
              src="https://www.youtube.com/embed/OqtvVGt7a60?autoplay=1&mute=1"
              title="Sweetest Home Visit | Junaid Akram"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            >
            </iframe>
            <!-- </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="celebrity_right">
        <p class="heading">
          Get a glimpse into everyday life at Pakistan Sweet Home.
        </p>
        <p class="celebrity_des">
          I saw first hand that orphaned children here have access to
          exceptional education and training and the best food, environment and
          playgrounds for recreational and healthy activities.
          <!-- <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.01039 1.17559V3.74663C9.01039 4.09532 9.29027 4.37785 9.63553 4.37785C10.8674 4.37785 11.5375 5.65383 11.6303 8.17221H9.63553C9.29027 8.17221 9.01039 8.45501 9.01039 8.80357V14.2322C9.01039 14.5807 9.29027 14.8633 9.63553 14.8633H14.9541C15.2995 14.8633 15.5791 14.5805 15.5791 14.2322V8.80357C15.5791 7.5963 15.4587 6.48844 15.2215 5.51038C14.9781 4.50752 14.6046 3.63068 14.1116 2.90412C13.6042 2.15744 12.9696 1.57151 12.2253 1.16332C11.4759 0.75266 10.6044 0.544373 9.63531 0.544373C9.29027 0.544373 9.01039 0.8269 9.01039 1.17559ZM0.948076 4.37789C0.602987 4.37789 0.322886 4.0951 0.322886 3.74667V1.17563C0.322886 0.826944 0.602943 0.544417 0.948076 0.544417C1.91678 0.544417 2.78838 0.752748 3.53751 1.16336C4.28202 1.57155 4.91695 2.15748 5.42436 2.90417C5.91721 3.63072 6.29075 4.50761 6.53414 5.51069C6.77128 6.48906 6.89165 7.59692 6.89165 8.80361V14.2322C6.89165 14.5807 6.61168 14.8633 6.2665 14.8633H0.94812C0.603031 14.8633 0.323192 14.5805 0.323192 14.2322V8.80357C0.323192 8.45505 0.602987 8.17221 0.94812 8.17221H2.91446C2.82299 5.65388 2.16271 4.37789 0.948076 4.37789Z"
              fill="#075595"
            />
          </svg> -->
        </p>
        <p class="celebrity_name">Junaid Akram</p>
        <p class="celebrity_work">Internet Celebrity</p>
      </div>
    </div>
  </div>
</section>
<section class="legal_section">
  <div class="container">
    <div *ngIf="btnTransparency" class="legal_trans">
      <svg
        width="106"
        height="106"
        viewBox="0 0 106 106"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="53" cy="53" r="53" fill="url(#paint0_linear_1512_13)" />
        <g clip-path="url(#clip0_1512_13)">
          <path
            d="M45.2063 27.53H59.8029C60.2514 27.53 60.6142 27.1668 60.6142 26.7187C60.6142 26.2707 60.2514 25.9075 59.8029 25.9075H45.2063C44.7578 25.9075 44.395 26.2707 44.395 26.7187C44.395 27.1668 44.7578 27.53 45.2063 27.53Z"
            fill="black"
          />
          <path
            d="M34.7405 34.6484H72.0493C72.4978 34.6484 72.8606 34.2852 72.8606 33.8372C72.8606 33.3891 72.4978 33.0259 72.0493 33.0259H34.7405C34.292 33.0259 33.9292 33.3891 33.9292 33.8372C33.9292 34.2853 34.292 34.6484 34.7405 34.6484Z"
            fill="black"
          />
          <path
            d="M34.7405 41.7666H72.0493C72.4978 41.7666 72.8606 41.4033 72.8606 40.9553C72.8606 40.5073 72.4978 40.144 72.0493 40.144H34.7405C34.292 40.144 33.9292 40.5073 33.9292 40.9553C33.9292 41.4033 34.292 41.7666 34.7405 41.7666Z"
            fill="black"
          />
          <path
            d="M34.7405 48.885H72.0493C72.4978 48.885 72.8606 48.5217 72.8606 48.0737C72.8606 47.6257 72.4978 47.2625 72.0493 47.2625H34.7405C34.292 47.2625 33.9292 47.6257 33.9292 48.0737C33.9292 48.5217 34.292 48.885 34.7405 48.885Z"
            fill="black"
          />
          <path
            d="M34.7405 56.0029H72.0493C72.4978 56.0029 72.8606 55.6397 72.8606 55.1916C72.8606 54.7436 72.4978 54.3804 72.0493 54.3804H34.7405C34.292 54.3804 33.9292 54.7436 33.9292 55.1916C33.9292 55.6398 34.292 56.0029 34.7405 56.0029Z"
            fill="black"
          />
          <path
            d="M34.7405 63.1208H53.395C53.8435 63.1208 54.2063 62.7576 54.2063 62.3096C54.2063 61.8616 53.8435 61.4983 53.395 61.4983H34.7405C34.292 61.4983 33.9292 61.8616 33.9292 62.3096C33.9292 62.7576 34.292 63.1208 34.7405 63.1208Z"
            fill="black"
          />
          <path
            d="M27.8972 22.4545V23.3322L24.732 24.1491C21.9972 24.859 20.3422 27.6631 21.0424 30.4016C23.7358 40.8273 26.3944 51.1183 27.897 56.9349V82.7559C27.897 85.2744 29.9466 87.3236 32.4652 87.3236H35.7453L35.8402 87.6931C36.545 90.4342 39.3542 92.0842 42.0942 91.3838L57.8193 87.3234H74.3216C76.8401 87.3234 78.8898 85.2743 78.8898 82.7557V81.8817L82.0579 81.0639C84.7943 80.3535 86.4495 77.5459 85.7466 74.8026L78.8896 48.2579V22.4545C78.8896 19.9355 76.84 17.8863 74.3214 17.8863H71.0439L70.9497 17.5215C70.2461 14.7601 67.4477 13.1175 64.6956 13.8292L48.9849 17.8863H32.4653C29.9468 17.8863 27.8972 19.9355 27.8972 22.4545ZM25.1386 25.7198L27.8972 25.0078V36.7114L27.444 36.502C23.1632 34.5654 22.7829 30.3571 22.6144 29.998C22.1352 28.1247 23.2681 26.2054 25.1386 25.7198ZM24.2453 36.3123C24.9889 36.9852 25.8329 37.5537 26.7699 37.9777L27.8973 38.4984V50.4502L24.2453 36.3123ZM41.6912 89.8125C39.8216 90.2891 37.9201 89.1727 37.4246 87.3236H51.3297L41.6912 89.8125ZM84.1759 75.2069C84.6568 77.0846 83.5239 79.0074 81.6518 79.4933L78.8901 80.2061V54.7429L84.1759 75.2069ZM65.1015 15.4003C66.9719 14.9182 68.8643 16.0111 69.3643 17.8865H55.4742L65.1015 15.4003ZM29.5197 22.4545C29.5197 20.8304 30.8413 19.5089 32.4653 19.5089H74.3219C75.946 19.5089 77.2675 20.8304 77.2675 22.4545V82.7559C77.2675 84.38 75.946 85.701 74.3219 85.701H32.4653C30.8413 85.701 29.5197 84.38 29.5197 82.7559V22.4545Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.732 24.1491L27.8972 23.3322V25.0078L25.1386 25.7198C23.2681 26.2054 22.1352 28.1247 22.6144 29.998C22.6364 30.0449 22.6621 30.1576 22.6996 30.3225C22.949 31.4185 23.7227 34.8185 27.444 36.502L27.8972 36.7114L27.8973 38.4984L26.7699 37.9777C25.8329 37.5537 24.9889 36.9852 24.2453 36.3123L27.8973 50.4502L27.897 56.9349L21.0424 30.4016C20.3422 27.6631 21.9972 24.859 24.732 24.1491ZM35.7453 87.3236L35.8402 87.6931C36.545 90.4342 39.3542 92.0842 42.0942 91.3838L57.8193 87.3234L51.3297 87.3236L41.6912 89.8125C39.8216 90.2891 37.9201 89.1727 37.4246 87.3236H35.7453ZM78.8898 81.8817L82.0579 81.0639C84.7943 80.3535 86.4495 77.5459 85.7466 74.8026L78.8896 48.2579L78.8901 54.7429L84.1759 75.2069C84.6568 77.0846 83.5239 79.0074 81.6518 79.4933L78.8901 80.2061L78.8898 81.8817ZM71.0439 17.8863L70.9497 17.5215C70.2461 14.7601 67.4477 13.1175 64.6956 13.8292L48.9849 17.8863L55.4742 17.8865L65.1015 15.4003C66.9719 14.9182 68.8643 16.0111 69.3643 17.8865L71.0439 17.8863Z"
            fill="#00AAE9"
          />
          <path
            d="M65.3772 65.7679C61.2503 65.7679 57.8936 69.1252 57.8936 73.2516C57.8936 77.3825 61.2503 80.7428 65.3772 80.7428C69.5041 80.7428 72.8609 77.3825 72.8609 73.2516C72.8609 69.1252 69.5041 65.7679 65.3772 65.7679ZM65.3772 79.1202C62.1456 79.1202 59.5161 76.4876 59.5161 73.2516C59.5161 70.0197 62.1456 67.3905 65.3772 67.3905C68.6089 67.3905 71.2383 70.0197 71.2383 73.2516C71.2383 76.4876 68.6089 79.1202 65.3772 79.1202Z"
            fill="#00AAE9"
          />
        </g>
        <defs>
          <lineargradient
            id="paint0_linear_1512_13"
            x1="53"
            y1="0"
            x2="53"
            y2="106"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F5F6FD" />
            <stop offset="1" stop-color="white" />
          </lineargradient>
          <clippath id="clip0_1512_13">
            <rect
              width="78.3134"
              height="78.3134"
              fill="white"
              transform="translate(14.2388 13.4478)"
            />
          </clippath>
        </defs>
      </svg>
      <p>Our Commitment to Accountability and Legal Transparency</p>
      <ul>
        <li>
          Fully compliant with all regulatory bodies such as SECP, NAB, and the
          GOP.
        </li>
        <li>
          Maintains accurate financial records and undergo regular audits.
        </li>
        <li>Third-party accreditation and monitoring.</li>
      </ul>
      <a href="why-us#transperancyFiles" data-scroll-to="#scroll-section4">
        View Certificates and Approvals
      </a>
    </div>
    <div *ngIf="!btnTransparency" class="legal_trans volunteer">
      <svg
        width="106"
        height="106"
        viewBox="0 0 106 106"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="53" cy="53" r="53" fill="url(#paint0_linear_867_1524)" />
        <g clip-path="url(#clip0_867_1524)">
          <path
            d="M31.4096 52.6047L30.8404 52.0356C29.732 50.9271 29.1585 49.3927 29.2682 47.8288L29.5527 43.7783C29.6625 42.2146 29.0889 40.68 27.9806 39.5717L15.3784 26.9695"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M25.8984 16.4497L38.4544 29.0058C39.731 30.2822 41.5597 30.8384 43.3307 30.4887L46.2147 29.9193C47.7684 29.6124 49.3787 30.0016 50.621 30.984L53.3959 33.427"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.3784 26.9695L25.8981 16.4498L34.0624 24.6141L23.5427 35.1338L15.3784 26.9695Z"
            stroke="#00AAE9"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M75.9507 52.0352C77.0592 50.9267 77.6326 49.3922 77.5228 47.8284L77.2384 43.778C77.1286 42.2142 77.7022 40.6796 78.8105 39.5712L91.4127 26.969"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M80.8932 16.4495L68.337 29.0056C67.0606 30.282 65.2319 30.8382 63.4609 30.4885L60.577 29.9191C59.0231 29.6122 57.4128 30.0014 56.1706 30.9838L51.2603 35.3066"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M91.4125 26.9695L80.8928 16.4498L72.7285 24.6141L83.2482 35.1338L91.4125 26.9695Z"
            stroke="#00AAE9"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M34.6464 49.3674L30.8404 53.1734C29.732 54.2819 29.1585 55.8163 29.2683 57.3801L29.5527 61.4306C29.6625 62.9944 29.0891 64.529 27.9806 65.6375L15.3784 78.2395"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M41.4086 42.6051L38.4258 45.5879"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M25.8984 88.7592L38.4544 76.203C39.731 74.9266 41.5597 74.3704 43.3307 74.7201L46.2147 75.2896C47.7684 75.5964 49.3787 75.2073 50.621 74.2248L53.7252 71.3378"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.3784 78.2395L25.8981 88.7592L34.0624 80.5948L23.5427 70.0751L15.3784 78.2395Z"
            stroke="#00AAE9"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M61.9375 54.5945L47.091 39.7478C45.9046 38.5615 45.9046 36.6379 47.091 35.4514C48.2774 34.265 50.2011 34.265 51.3874 35.4514L64.4266 48.4905"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M61.9641 54.5678L45.2258 37.8295C44.0395 36.6432 42.1159 36.6432 40.9294 37.8295C39.7429 39.016 39.7429 40.9395 40.9294 42.126L57.6677 58.8641"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M57.6738 58.8582L45.9525 47.1368C44.766 45.9504 42.8425 45.9504 41.656 47.1368C40.4695 48.3233 40.4695 50.2469 41.656 51.4332L53.3773 63.1545"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M77.7224 64.0537C77.2086 62.9992 77.0412 61.7915 77.2746 60.6093L77.848 57.7048C78.157 56.1401 77.7651 54.5184 76.7758 53.2673L70.1796 44.9269C69.2459 43.4037 67.2866 42.8725 65.7116 43.7158C63.9914 44.6366 63.409 46.8203 64.4419 48.4755L66.0091 50.5232"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M91.4128 78.165L81.3052 68.0574"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M53.3776 63.1546L47.9714 57.7484C46.8895 56.6665 45.1354 56.6665 44.0536 57.7484C42.9717 58.8302 42.9717 60.5843 44.0536 61.6662L55.5751 73.1878C56.6914 74.304 58.2369 74.8816 59.8116 74.771L63.8909 74.4845C65.4657 74.3741 67.011 74.9515 68.1275 76.0679L80.8188 88.7593"
            stroke="black"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M80.8188 88.7593L91.4132 78.1649L83.191 69.9428L72.5967 80.5371L80.8188 88.7593Z"
            stroke="#00AAE9"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <lineargradient
            id="paint0_linear_867_1524"
            x1="53"
            y1="0"
            x2="53"
            y2="106"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F5F6FD" />
            <stop offset="1" stop-color="white" />
          </lineargradient>
          <clippath id="clip0_867_1524">
            <rect
              width="78.3134"
              height="78.3134"
              fill="white"
              transform="translate(14.2388 13.4478)"
            />
          </clippath>
        </defs>
      </svg>
      <p>Volunteer</p>
      <ul>
        <li>
          Contribute directly towards the well-being of the future generation.
        </li>
        <li>Network with other professionals who share your passion.</li>
        <li>Gain skills and knowledge of community- based work.</li>
      </ul>
      <a href="javascript:;" routerLink="/get-involved"> Apply Now </a>
    </div>
  </div>
</section>
<section class="star_section">
  <div class="container p-0">
    <div class="swiper-container heroSlider">
      <div class="writers__Controls_two">
        <div
          class="swiper-button-prev hero-prev"
          tabindex="0"
          role="button"
          aria-label="Previous slide"
        ></div>
        <div
          class="swiper-button-next hero-next"
          tabindex="0"
          role="button"
          aria-label="Next slide"
        ></div>
      </div>
      <div class="hero_swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am studying in class Prep. I've been living in Sweet Home
                  for last one year. I came here from Khyber Agency. Papa Jani
                  loves me a lot. My best friend is Maimoona. When I grow up, I
                  want to become a Pilot.
                </p>
                <p class="hero_name">Seema Hakeem</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/seema.jpg" alt="seema" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Murree. I'm 13 years old, and I study in class 6th.
                  I've been living in Pakistan Sweet home for three years. My
                  favorite subject is Maths, and I want to become an Astronaut.
                  I love to play football and Cricket.
                </p>
                <p class="hero_name">Saif Ullah Iftekhar</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/saif.jpg" alt="saif" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Murree, and I've been living in Sweet Home for two
                  years. I am studying in class 2. I love to play football and
                  want to become a Footballer when I grow up.
                </p>
                <p class="hero_name">Mamin Raza</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/mamin.jpg" alt="mamin" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am Tayyab from Khyber Agency. I have been living in Sweet
                  Home since 2010. Currently, I am pursuing a Bachelor's Degree
                  in Software Engineering from Szabist University Islamabad.
                  Alongside, I am working on a part-time internship at a
                  reputable IT firm in Islamabad. I aspire to become a
                  Bureaucrat in the future.
                </p>
                <p class="hero_name">Tayyab Afridi</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/tayab.jpg" alt="tayab" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Parachinar, and I've been living in Sweet Home since
                  2011. Alhamdulillah, I passed my FSc from Cadet College Sohawa
                  with 86% marks. I am doing LLB from The Institute of Legal
                  Studies (TILS). In my free time, I love to read books. In the
                  future, I aspire to become the Prime Minister of Pakistan.
                </p>
                <p class="hero_name">Syed Husnain Ali Shah</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/husnain.jpg" alt="husnain" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Rawalpindi, and I've been living in Sweet Home for
                  the last ten years. Alhamdulillah, I am doing FSc
                  (Pre-Engineering) from Divisional Public School & College with
                  the goal of joining forces as an Engineer.
                </p>
                <p class="hero_name">Tehreem Zainab</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/tehreem.jpg" alt="tehreem" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am Ameer Khan from Gilgit. I've been living in Pakistan
                  Sweet Home for the last 10 years. I passed my FSc exams with
                  901/1100 marks and am currently doing Computer Engineering at
                  NUTECH University, Islamabad. Additionally, I am contributing
                  to the media team of Pakistan Sweet Home after university
                  hours as a gesture of gratitude to the place that has given me
                  so much!
                </p>
                <p class="hero_name">Ameer Khan</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/ameer.jpg" alt="ameer" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Mardan, Khyber Pakhtunkhwa. I've been living in
                  Pakistan Sweet Home for the last 10 years. I passed my
                  secondary school exam with 987/1100 marks and am currently
                  doing BS in English language & literature from Quaid-e-Azam
                  University, Islamabad.
                </p>
                <p class="hero_name">Shah Faisal</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/faisal.jpg" alt="faisal" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="main_hero">
              <div class="hero_left">
                <h3>
                  Introducing the Brightest Stars in Our Orphan Care Program
                </h3>
                <p class="hero_des">
                  I am from Kohistan, Khyber Pakhtunkhwa. I've been living in
                  Pakistan Sweet Home for the last 12 years. I've passed my FSC
                  exam with 94% marks and am currently doing Pharm.D from
                  Quaid-e-Azam University, Islamabad.
                </p>
                <p class="hero_name">Asmat Ullah</p>
              </div>
              <div class="hero_right">
                <div class="hero_img">
                  <img src="assets/images/asmat.jpg" alt="asmat" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination hero"></div>
      </div>
    </div>
  </div>
</section>
<section class="our_founder">
  <div class="container">
    <div class="founder_head">
      <p>our founder</p>
      <h2>How it all started</h2>
    </div>
    <div class="main_founder">
      <div class="founder_left">
        <img src="assets/images/aj_founder_new.png" alt="Zamurrad Khan" />
      </div>
      <div class="founder_right">
        <p class="founder_name">
          Zamurrad Khan <span>(CEO Pakistan Sweet Home)</span>
        </p>
        <p class="award">Hilal-e-Imtiaz</p>
        <p class="visit">
          During a visit to Swat Operation Raah e Raast with former Prime
          Minister, I was stunned by the heartbreaking conditions faced by
          orphaned children.
        </p>
        <p class="bf_img">
          I couldn't just walk away and leave them there without help. I felt an
          immediate need to take action and make a difference.
        </p>
        <p>
          That's when I turned to my family and friends, and we made a decision
          to adopt a child.
        </p>
        <p class="last_p">
          That single act of kindness and compassion planted the seed for what
          would become Pakistan Sweet Home, a foundation dedicated to providing
          safe and loving homes for orphaned children in need.
        </p>
        <a href="javascript:;" routerLink="/about-us">Discover Our Story</a>
      </div>
    </div>
  </div>
</section>
<section class="blessing_section">
  <div class="container">
    <h2>Join us in Empowering Orphans in Pakistan</h2>
    <div class="main_blessing">
      <div class="blessing_left">
        <p>With your support, we can:</p>
        <ul>
          <li>Build schools.</li>
          <li>Provide educational resources and school supplies.</li>
          <li>Improve health facilities.</li>
          <li>Create livelihood opportunities and much more...</li>
        </ul>
        <p>Be a blessing to these children</p>
        <a href="javascript:;" routerLink="/donate">Donate Now</a>
      </div>
      <div class="blessing_right">
        <img src="assets/images/aj_blessing.jpg" alt="blessings" />
      </div>
    </div>
  </div>
</section>

<!-- Qurbani Modal Start -->
<!-- <section class="modal-section">
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="left-pane">

      </div>
      <div class="right-pane">
        <div class="cancelBtn">
          <img src="../../../assets/images/modal-homepage/cancel.svg" alt="close modal" />
        </div>
        <div>
          <h3>We are Accepting</h3>
          <h2>Qurbani Donations</h2>
        </div>
        <div>
          <p>Orphans and their families have Eid too.</p>
          <p class="txt_notForgotten">Let them know they're not forgotten!</p>
        </div>
        <div>
          <p class="txt_price_per_goat">Goat/Sheep PKR 60,000/-</p>
        </div>

        <div class="btnWrapper">
          <button class="btn_donate_now">Donate Now</button>
          <a class="btn_skip">Skip</a>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- Qurbani Modal Ends -->
